import React from "react";
import * as XLSX from "xlsx";
import { FaRegFileExcel } from "react-icons/fa";
import { Button } from "@mui/material";

export default function ExportToExcelBTN({ data }) {
  const handleDownload = () => {
    // Transform the data to update the ImgName field only if it exists in the object
    const transformedData = data.map(
      (item) =>
        item.hasOwnProperty("ImgName") // Check if the key exists
          ? {
              ...item,
              ImgName: item.ImgName
                ? `https://www.apsgroupapp.com/uploads/${item.ImgName}`
                : item.ImgName, // Concatenate if ImgName is valid
            }
          : item // Leave other objects unchanged
    );

    // Create a new workbook and add a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(transformedData);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file (in binary string format) and trigger download
    XLSX.writeFile(wb, "table_data.xlsx");
  };

  return (
    <Button onClick={handleDownload}>
      <FaRegFileExcel size={18} />
    </Button>
  );
}
